<template>
  <footer class="mt-5">
    <div class="container">
      <hr />
      <div class="row text-center">
        <div class="col-sm-12 col-md-4">
          <p>Tutorial by Wahiddev Academy</p>
        </div>
        <div class="col-sm-12 col-md-4">
          <p><strong>Created by Riza Ardiansyah</strong></p>
        </div>
        <div class="col-sm-12 col-md-4">
          <p>2021 Copyright</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scope>
footer {
  /* height: 50px; */
  padding: 10px;
}
</style>
